import React, { Component } from "react";
import { getUsers, deleteUser, userRole } from "../services/userService";
import Spinner from "./common/spinner";
import UsersTable from "./usersTable";
import Alert from "./common/alert";
import NotFound from "./notFound";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import auth from "../services/authService";
import CsvDownload from "react-json-to-csv";

class Users extends Component {
  state = {
    users: [],
    loading: false,
  };

  async componentDidMount() {
    this.setState({ loading: true });
    const users_response = await getUsers();

    const { data: users } = users_response.data;
    this.setState({ users });
    this.setState({ loading: false });
  }

  handleDelete = async (user) => {
    const originalUsers = this.state.users;
    const users = originalUsers.filter((u) => u._id !== user._id);
    this.setState({ users });

    try {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <Alert
              name="User"
              onClose={() => {
                this.setState({ users: originalUsers });
                onClose();
              }}
              onDelete={async () => {
                await deleteUser(user._id);
                onClose();
              }}
            />
          );
        },
      });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        toast("This user has already been deleted.");

      this.setState({ users: originalUsers });
    }
  };

  handleUserRoleSwitch = async (user) => {
    const users = [...this.state.users];
    const index = users.indexOf(user);
    users[index] = { ...users[index] };
    users[index].isAdmin = !users[index].isAdmin;
    await userRole(users[index]);
    this.setState({ users });
  };

  getPagedData = () => {
    const { users } = this.state;

    return { data: users };
  };

  render() {
    const { loading } = this.state;
    const { data: users } = this.getPagedData();
    const { isAdmin } = auth.getCurrentUser();
    //const filteredUsers = users.filter(user => !user.isAdmin);

    console.log(this.state.users);

    if (loading) return <Spinner message="loading page data..." />;
    return isAdmin ? (
      <React.Fragment>
        {this.state.users.length ? (
          <CsvDownload
            data={this.state.users}
            className="btn btn-success mb-5 ml-auto"
          >
            Download emails
          </CsvDownload>
        ) : (
          <></>
        )}

        <UsersTable
          users={users}
          onDelete={this.handleDelete}
          onRoleSwitch={this.handleUserRoleSwitch}
          message="Users"
        />
      </React.Fragment>
    ) : (
      <NotFound />
    );
  }
}

export default Users;
